
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { LEGAL_LINKS, SOCIAL_LINKS } from '../model';
import { CURRENT_YEAR } from '@/constants/common';

import cls from './styles.module.pcss';
import layoutCls from '@shared/assets/styles/modules/layout.module.pcss';
import LestaLogo from './assets/lesta-logo.svg';
import PGLogo from './assets/pg.svg';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={cls.Footer}>
      <div className={cn(cls.FooterContent, layoutCls.Container)}>
        <div className={cls.FooterAbout}>
          <img
            className={cls.FooterLogo}
            src={LestaLogo}
            alt="Леста Игры"
            height={72}
            loading='lazy'
          />
          <p className={cls.FooterCopyright}>
            <span>{t('footer.copyright.text')}</span>
            <span>{t('footer.copyright.date', { currentYear: CURRENT_YEAR })}</span>
          </p>
        </div>

        <div className={cls.FooterSocials}>
          <h4 className={cls.FooterSocialsTitle}>{t('footer.socials.title')}</h4>
          <ul className={cls.FooterSocialsList}>
            {SOCIAL_LINKS.map((social) => (
              <li className={cls.FooterSocialsItem} key={social.title}>
                <a href={social.link} target="_blank">
                  <img src={social.img} alt={social.title} loading='lazy' />
                  {social.title}
                </a>
              </li>
            ))
            }
          </ul>
        </div>

        <div className={cls.FooterLegal}>
          <ul className={cls.FooterLegalLinks}>
            {LEGAL_LINKS.map((legal) => (
              <li className={cls.FooterLegalItem} key={legal.link}>
                <a href={legal.link} target="_blank">{t(legal.title)}</a>
              </li>
            ))}
          </ul>

          <img className={cls.FooterLegalRating} src={PGLogo} alt="PG" loading='lazy' />
        </div>
      </div>
    </footer>
  );
}
